import axiosInstance from "../axios/axios_instance"
const http = axiosInstance("/protected",  null, "/surveys")

const INSUFFICIENT_COMMON_PARTICIPANTS_MESSAGE =
    "In order to run a comparison summary you must have at least 2 participants in common for each survey"

const isInsufficientCommonParticipants = (err) => {
    const title = err?.response?.data?.title
    const description = err?.response?.data?.description
    return title === "Insufficient common participants"
        || description === "Not enough common complete responses"
        || description === "Not enough complete responses"
}

const demoFlag = (demo) => (demo === true || demo === "true" ? "true" : "false")

const getComparisons = (firstId, secondId) => http.get("/comparison/" + firstId + "/" + secondId)
const getDemoComparisons = (firstId, secondId) => http.get("/demo_comparison/" + firstId + "/" + secondId)
const getComparableSurveys = (team_id, demo) => http.get("/comparison_surveys/" + team_id + "/" + demo)
const getComparisonOverlap = (firstId, secondId, demo) =>
    http.get("/comparison_overlap/" + firstId + "/" + secondId + "/" + demoFlag(demo))

export default {
    getComparisons,
    getDemoComparisons,
    getComparableSurveys,
    getComparisonOverlap,
    isInsufficientCommonParticipants,
    INSUFFICIENT_COMMON_PARTICIPANTS_MESSAGE
}
